import React from "react";

// Modern Explorer Picks logo — a compass rose + football stitch mark
const Logo = ({ size = 40, variant = "light" }) => {
  const isDark = variant === "dark";
  const primary = isDark ? "#0a1a4a" : "#ffffff";
  const accent = "#ff5a5a";

  return (
    <div className="flex items-center gap-2.5 select-none">
      <div
        className="relative flex items-center justify-center rounded-xl"
        style={{ width: size, height: size, background: accent }}
      >
        <svg
          width={size * 0.62}
          height={size * 0.62}
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 3 L23.5 16.5 L37 20 L23.5 23.5 L20 37 L16.5 23.5 L3 20 L16.5 16.5 Z"
            fill={primary}
          />
          <circle cx="20" cy="20" r="3" fill={accent} />
        </svg>
      </div>
      <div className="leading-none">
        <div
          className="font-extrabold tracking-tight"
          style={{
            color: primary,
            fontFamily: "'Sora', sans-serif",
            fontSize: size * 0.42,
            lineHeight: 1,
          }}
        >
          Explorer<span style={{ color: accent }}>Picks</span>
        </div>
        <div
          className="uppercase font-semibold"
          style={{
            color: isDark ? "#0a1a4a99" : "#ffffffb0",
            fontSize: size * 0.19,
            letterSpacing: "0.22em",
            marginTop: 4,
          }}
        >
          Football Predictions
        </div>
      </div>
    </div>
  );
};

export default Logo;
